import React from "react";
import PropTypes from "prop-types";
import SectionItem from "./SectionItem.jsx";

export const EmailDeliveryComponent = (props) =>
  (props.emailGroup && props.emailGroup.emailList && (
    <span>
      <SectionItem itemKey={"Email Delivery"}>Enabled</SectionItem>
      <SectionItem itemKey={"Email Address(es)"}>
        {props.emailGroup.emailList.map((email, idx) => (
          <div key={idx}>{email.email}</div>
        ))}
      </SectionItem>
    </span>
  )) ||
  null;

export default EmailDeliveryComponent;

EmailDeliveryComponent.propTypes = { emailGroup: PropTypes.object };
